import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './browserCompatibility.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initViewportFixes } from './viewportFix';

// Initialiser les fixes de compatibilité navigateur
initViewportFixes();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
